import React, { FC } from 'react';
import classNames from 'classnames'

import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";
import { makeStyles, Theme } from "@material-ui/core/styles";

import { commonStyles } from "theme/common";

const useStyles = makeStyles((theme: Theme) => {
    return {
        body: {
            color: theme.palette.primary.light,
        },
        dark: {
            color: theme.palette.primary.dark
        },
        ...commonStyles(theme),
    };
});

interface MailToLinkProps {
    dark?: boolean;
}

const MailToLink: FC<MailToLinkProps> = ({ dark }) => {
    const classes = useStyles();

    return <Link href="mailto:marta@kamocsai.com">
        <Typography variant="body2" className={classNames(classes.body, { [classes.dark]: dark })}>
            marta@kamocsai.com
        </Typography>
    </Link >
}

export default MailToLink